<div class="page">
  <!-- ----header -->
  <div class="subheader header">
    <i class="icon-angle-double-left" (click)="order.closeSidebar()"></i>
    <div class="driverfastheader">
      <i class="usericon icon-moped-o"> </i
      ><span> {{ "ClientApp.FrontOffice.Order.OrderPage.Fastaccess.DriverAssignmentFastaccess.TitleHeader" | translate }}</span>
    </div>
    <i class="icon-th"></i>
  </div>
  <div class="content-box">
    <div class="peykorder">
      <div class="searchpeyk">
        <ssg-input
          [name]="driverservice.inputSearch"
          [label]="'ClientApp.FrontOffice.Order.OrderPage.Fastaccess.DriverAssignmentFastaccess.SearchInput' | translate"
          [group]="driverservice.formGroup"
          required="false"
          textType="text"
          [disabled]="false">
        </ssg-input>
        <ssg-input
          (onEnter)="driverservice.barCodeFinder($event)"
          [name]="driverservice.inputBarCode"
          [label]="'ClientApp.FrontOffice.Order.OrderPage.Fastaccess.DriverAssignmentFastaccess.BarCode' | translate"
          [group]="driverservice.formGroup"
          required="false"
          textType="text"
          [disabled]="false">
        </ssg-input>
      </div>
      <!-- ---------------title--------------- -->
      <div class="title">
        <span class="name">{{ "ClientApp.FrontOffice.Order.OrderPage.Fastaccess.DriverAssignmentFastaccess.FactorsTitle" | translate }}</span>
      </div>
    </div>
    <!-- ---------condition------------------ -->
    <div class="condition">
      <ul class="group">
        <li
          *ngFor="let item of driverservice.invoiceFilter"
          [class.statusClickedBg]="item.selected"
          class="tablecondition preparingStatus"
          [ngClass]="{ gray: item.key === 0, orange: item.key === 1, red: item.key === 2 }"
          (click)="item.selected = !item.selected; driverservice.invoiceFilterByStatus()">
          <div class="statusicon"></div>
          <div class="d-flex">
            <div class="statustext">{{ item.title }}</div>
            <span class="statustext">{{ item.count }}</span>
          </div>
        </li>
      </ul>
    </div>
    <!-- -------------card-------------- -->
    <div class="peykcardbox">
      <div
        *ngFor="
          let invoice of driverservice.currentInvoices
            | filter
              : {
                  NumberingInDate: driverservice.formGroup.controls[driverservice.inputSearch]?.value,
                  DriverId: driverservice.formGroup.controls[driverservice.inputSearch]?.value,
                  CustomerName: driverservice.formGroup.controls[driverservice.inputSearch]?.value,
                  CustomerNumber: driverservice.formGroup.controls[driverservice.inputSearch]?.value,
                  PayableTotal: driverservice.formGroup.controls[driverservice.inputSearch]?.value
                };
          let index = index
        "
        class="subinfocall callcard"
        [class.selected]="invoice.Selected"
        (click)="!driverservice.isShowAssignInvoice && (invoice.Selected = !invoice.Selected)">
        <div
          class="callcolor"
          [ngClass]="{
            gray: invoice.DriverAssignmentStatus === driverservice.driverAssignmentStatus.Preparing,
            orange: invoice.DriverAssignmentStatus === driverservice.driverAssignmentStatus.DelayInPreparation,
            red: invoice.DriverAssignmentStatus === driverservice.driverAssignmentStatus.ExcessivePreparationDelay
          }"></div>
        <div class="callcontent">
          <div>
            {{ "ClientApp.FrontOffice.Order.OrderPage.Fastaccess.DriverAssignmentFastaccess.FactorsTitle" | translate }} {{ invoice.NumberingInDate }}
          </div>
          <div class="line">
            <span
              >{{ invoice.FactorStringTime }} {{ "ClientApp.FrontOffice.Order.OrderPage.Fastaccess.DriverAssignmentFastaccess.AgoTitle" | translate }}
            </span>
          </div>
        </div>
        <i class="icon-check_circle-f" [class.showicon]="invoice.Selected"></i>
      </div>
    </div>
    <!-- ---------title------------------ -->
    <div class="title">
      <span class="name">{{ "ClientApp.FrontOffice.Order.OrderPage.Fastaccess.DriverAssignmentFastaccess.DriverTitle" | translate }}</span>
    </div>
    <!-- ---------condition------------------ -->
    <div class="condition">
      <ul class="group drive">
        <ng-container *ngFor="let item of driverservice.DriverFilter">
          <li
            class="greenBg driverstatus driver"
            *ngIf="item.hasFastAccess"
            [class.driver-event]="item.key === driverservice.currentDriverFilter"
            (click)="driverservice.driverFilterByStatus(item.key)">
            {{ item.title }}
          </li>
        </ng-container>
      </ul>
    </div>
    <!-- ------------peykname------------- -->
    <div class="peyk-box">
      <div class="peykcard">
        <div *ngFor="let driver of driverservice.currentDrivers" class="peykname">
          <div class="drivername">
            {{ driver.DisplayName }}
            <div class="drivercount">{{ driver.DriverAssignmentInvoicesCount }}</div>
          </div>
          <div class="assign">
            <span>{{ driver.AssignmentInvoicesTotal | number | persianNumber }}</span>
            <i class="icon-cash-multiple assign-icon"></i>
          </div>
          <div class="drivercondition" *ngIf="driverservice.currentDriverFilter === driverservice.driverStatusShow.DriverIn">
            <div class="driveruse" [tooltip]="'ClientApp.FrontOffice.Order.OrderPage.Fastaccess.DriverAssignmentFastaccess.Assignment' | translate">
              <i
                class="icon-assignment_ind-o drivercardicon"
                (click)="driverservice.InvoiceAssigned(driver)"
                [ngClass]="driverservice.hasSelectItem() ? 'active' : 'noActive'"
                *ngIf="driverservice.currentDriverFilter === driverservice.driverStatusShow.DriverIn"
                focusable="false"></i>
            </div>

            <div class="driveruse" [tooltip]="'ClientApp.FrontOffice.Order.OrderPage.Fastaccess.DriverAssignmentFastaccess.Exit' | translate">
              <i
                class="icon-exit_to_app-o drivercardicon"
                *ngIf="driverservice.currentDriverFilter === driverservice.driverStatusShow.DriverIn"
                (click)="driverservice.ChangeDriverStatus(driver, driverservice.personnelState.Out)"></i>
            </div>
          </div>
          <div class="exitbox" *ngIf="driverservice.currentDriverFilter === driverservice.driverStatusShow.DriverOut">
            <div class="driveruse" [tooltip]="'ClientApp.FrontOffice.Order.OrderPage.Fastaccess.DriverAssignmentFastaccess.Return' | translate">
              <i class="icon-account-arrow-left drivercardicon" (click)="driverservice.ReturnOfDelivery(driver)"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
